module.exports = __webpack_public_path__ + "static/media/modern-earing_720x480.1e1ede27.jpg";